import React from 'react';

function Row1(props) {
    return (
        <div className="row">
            <div className="circle">

            </div>
            <div className="leftObject">
                <div className="squareObject">

                </div>
                <div className="lineObject">

                </div>
            </div>
            <div className="blank">

            </div>
            <div className="fill" id="fill">
                <div className="rightContainer">
                    <p id="fillHeading">{props.heading}</p>
                    <p id="category">{props.category}</p>
                    <p id="time">{props.time}</p>
                    <p id="content">{props.content}</p>
                </div>
            </div>
        </div>
    );
}
export default Row1;